import {Box, Text} from "@chakra-ui/react";

const DocumentationTab = () => {
    return (
        <Box p={6} h={"100%"}>
            {/*<iframe src={"https://docs.google.com/gview?url=https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/web/compressed.tracemonkey-pldi-09.pdf&embedded=true"} width={"100%"} height={"100%"}></iframe>*/}
            {/*<iframe src={"https://drive.google.com/file/d/1iUsILUQlshQaJmpKVwYco58gu0I-qP3E/view?usp=sharing"} width={"100%"} height={"100%"}></iframe>*/}
            {/*<iframe src="https://drive.google.com/embeddedfolderview?id=view#list" ></iframe>*/}
            <Text align={"left"} pb={4} fontSize={"xl"} fontWeight={"bold"}>Project Summary</Text>
            <iframe src="https://drive.google.com/file/d/1iUsILUQlshQaJmpKVwYco58gu0I-qP3E/preview" width="100%" height="100%" allow="autoplay"></iframe>
        </Box>
    )
}

export  default DocumentationTab;